export default __webpack_public_path__ + "static/media/vtex-platform-poster.24c203c4.png";